// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let walletBalance = await store
        .getState()
        .blockchain.web3.eth
        .getBalance(store.getState().blockchain.account)

      walletBalance = store
        .getState()
        .blockchain.web3.utils.fromWei(walletBalance, 'ether'); 
      walletBalance = parseFloat(walletBalance).toFixed(4)
      console.log("walletBalance " + walletBalance)

      let isInit = await store
        .getState()
        .blockchain.smartContract.methods.isInit()
        .call();
      console.log("isInit " + isInit)

      let isFinish = await store
        .getState()
        .blockchain.smartContract.methods.isFinish()
        .call();
      console.log("isFinish " + isFinish)

      let isRefund = await store
        .getState()
        .blockchain.smartContract.methods.isRefund()
        .call();
      console.log("isRefund " + isRefund)

      let raised = await store
        .getState()
        .blockchain.smartContract.methods.ethRaised()
        .call();
      console.log("raised " + raised)

      let contribution = await store
        .getState()
        .blockchain.smartContract.methods.ethContribution(store.getState().blockchain.account)
        .call();
        contribution = store
        .getState()
        .blockchain.web3.utils.fromWei(contribution, 'ether'); 
        contribution = parseFloat(contribution).toFixed(3)
      console.log("contribution " + contribution)

      let state = await store
        .getState()
        .blockchain.smartContract.methods.saleState()
        .call();
      console.log("state " + state)

      let pool = await store
        .getState()
        .blockchain.smartContract.methods.pool()
        .call();
      console.log("pool" + JSON.stringify(pool, null, 4))

      let claimRound = await store
        .getState()
        .blockchain.smartContract.methods.claimRound()
        .call();
      console.log("claimRound ", claimRound)

      let claims = await store
        .getState()
        .blockchain.smartContract.methods.claims(store.getState().blockchain.account)
        .call();
      console.log("claims" + JSON.stringify(claims, null, 4))

      dispatch(
        fetchDataSuccess({
          pool,
          isInit,
          isFinish,
          isRefund,
          walletBalance,
          state,
          raised,
          contribution,
          claimRound,
          claims
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
